import { useMemo } from "react";
import hash from "stable-hash";
export function useStableMemo(factory, deps) {
    return useMemo(factory, [
        hash(deps)
    ]);
}
